import React from 'react';

// 운동기구 카테고리 (덤벨)
const DumbbellIcon = ({ width = 24, height = 24, color = '#0F7F85' }) => (
  <svg width={width} height={height} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 9V13M20 9V13M4 7V15M18 7V15M4 11H18M6 6H8V16H6V6ZM14 6H16V16H14V6Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default DumbbellIcon;
